import { render } from "./detail_end.vue?vue&type=template&id=9074cbb0&scoped=true"
import script from "./detail_end.vue?vue&type=script&lang=js"
export * from "./detail_end.vue?vue&type=script&lang=js"

import "./detail_end.vue?vue&type=style&index=0&id=9074cbb0&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9074cbb0"]])

export default __exports__